import { useAppSelector } from "app/hooks";
import { useAuth } from "hooks/auth";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import { CategorySubType } from "types/sidebar";
import { getEnvVariable } from "utilities/env";

export const useGlobalSearch = () => {
  const { code } = useAppSelector(selectCurrentStoreData);
  const { fetcher } = useAuth();

  const searchGlobal = async (query: string) => {
    const encodedQuery = encodeURIComponent(query);
    const api = getEnvVariable("REACT_APP_API_URL");
    const itemsOnPageQuery = "_itemsOnPage=5";

    const urls = [
      `${api}/${code}/campaign?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/member?firstName[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/member?lastName[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/member?phone[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/member?loyaltyCardNumber[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/member?email[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/achievement?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/tier?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/walletType?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/reward?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
      `${api}/${code}/groupOfValues?name[like]=${encodedQuery}&${itemsOnPageQuery}`,
    ];

    const resp = await Promise.all(urls.map((url) => fetcher(url)))
      .then((results) => {
        return Promise.all(results.map((r) => (r.json ? r.json() : r)));
      })
      .then(
        ([
          campaigns,
          membersByFirstName,
          membersByLastName,
          membersByPhone,
          membersByLoyaltyCardNumber,
          membersByEmail,
          achievements,
          tiers,
          wallets,
          rewards,
          collections,
        ]) => {
          return [
            { label: "campaigns", type: "campaign", items: campaigns.items },
            {
              label: "members",
              type: "member",
              items: [
                ...membersByLastName.items.map((item: any) => ({
                  ...item,
                  subType: CategorySubType.LAST_NAME,
                })),
                ...membersByFirstName.items.map((item: any) => ({
                  ...item,
                  subType: CategorySubType.FIRST_NAME,
                })),
                ...membersByPhone.items.map((item: any) => ({
                  ...item,
                  subType: CategorySubType.PHONE,
                })),
                ...membersByLoyaltyCardNumber.items.map((item: any) => ({
                  ...item,
                  subType: CategorySubType.LOYALTY_CARD_NUMBER,
                })),
                ...membersByEmail.items.map((item: any) => ({
                  ...item,
                  subType: CategorySubType.EMAIL,
                })),
              ],
            },
            {
              label: "achievements",
              type: "achievement",
              items: achievements.items,
            },
            {
              label: "tiers",
              type: "tier",
              items: tiers.items,
            },
            {
              label: "wallets",
              type: "wallet",
              items: wallets.items,
            },
            {
              label: "rewards",
              type: "reward",
              items: rewards.items,
            },
            {
              label: "collections",
              type: "collection",
              items: collections.items,
            },
          ];
        },
      );

    return resp;
  };

  return { searchGlobal };
};
